"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRandomString = generateRandomString;
/**
 * Generates a random string of English characters (a-z, A-Z)
 * @param length - The length of the string to generate (default: 14)
 * @returns A random string of the specified length
 */
function generateRandomString(length = 14) {
    const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}
